import script from "./expansion-panel.vue?vue&type=script&lang=ts&setup=true"
export * from "./expansion-panel.vue?vue&type=script&lang=ts&setup=true"

import "./expansion-panel.vue?vue&type=style&index=0&id=1a546c53&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a546c53"]])

export default __exports__